export default __webpack_public_path__ + "static/hero_personal_back_img_3-a19ea28f2c0ab1a1601b4d09b20efbf7.png";